import React, { useCallback, useContext } from 'react'
import { DropzoneOptions, DropzoneState, useDropzone } from 'react-dropzone'
import { Button, cn } from 'ui'

interface UploadFileContextProps extends DropzoneState {}

const UploadFileContext = React.createContext<
  UploadFileContextProps | undefined
>(undefined)

const useUploadFile = () => useContext(UploadFileContext)!

export const UploadFileInput = React.forwardRef<
  HTMLInputElement,
  React.HTMLProps<HTMLInputElement>
>((props, ref) => {
  const file = useUploadFile()

  return <input {...props} {...file.getInputProps()} />
})

export const UploadFileOverState = () => {
  return <p>Soltar archivos aquí</p>
}

export const UploadFileEmptyState = () => {
  return (
    <div className='flex flex-col space-y-6 items-center text-center'>
      <p className='whitespace-normal'>
        Suelta aquí tus archivos o presiona subir
      </p>
      <Button type='button' size='sm' variant={'secondary'}>
        Subir
      </Button>
    </div>
  )
}

export interface UploadFileProps
  extends Omit<React.HTMLProps<HTMLDivElement>, 'children'> {
  dropzone: DropzoneOptions
  children?: React.FC<DropzoneState> | React.ReactNode
}

export const UploadFile = React.forwardRef<HTMLDivElement, UploadFileProps>(
  ({ dropzone, children, className, ...props }, ref) => {
    const file = useDropzone(dropzone)

    return (
      <UploadFileContext.Provider value={file}>
        <div
          {...file.getRootProps()}
          {...props}
          className={cn(
            'border-slate-200',
            'border p-3 rounded-md',
            {
              'border-primary': file.isDragActive,
            },
            'flex items-center justify-center py-20',
            'before:h-full relative before:w-full before:border-b',
            'before:rounded-md before:absolute before:border-primary before:bottom-4',
            className
          )}
          ref={ref}
        >
          {typeof children === 'function' ? children(file) : children}
        </div>
      </UploadFileContext.Provider>
    )
  }
)
